import initializeAdjacentAndConflictingMeetingsAction from '../actions/initializeAdjacentAndConflictingMeetingsAction';
import setConflictsRequestStatus from '../actions/setConflictsRequestStatus';
import processGetItemResponse from '../actions/processGetItemResponse';
import loadAdjacentAndConflictingMeetings from '../services/loadAdjacentAndConflictingMeetings';
import RequestStatus from '../store/schema/RequestStatus';
import { ClientItem } from 'owa-mail-store';
import { orchestrator } from 'satcheljs';

export default orchestrator(initializeAdjacentAndConflictingMeetingsAction, async actionMessage => {
    const { item, meetingRequestViewState } = actionMessage;

    setConflictsRequestStatus(RequestStatus.Pending, meetingRequestViewState);

    const response = await loadAdjacentAndConflictingMeetings(
        item.ItemId.Id,
        (<ClientItem>item).MailboxInfo.requestOptions
    );

    if (response) {
        // Mark request as succceeded
        processGetItemResponse(
            item.ItemId.Id,
            response.conflictingMeetings,
            response.adjacentMeetings,
            meetingRequestViewState
        );
    } else {
        // Mark request as failed
        setConflictsRequestStatus(RequestStatus.Error, meetingRequestViewState);
    }
});
